import type { TopicResponseBasicInfoAllOf } from './topicResponseBasicInfoAllOf';
import type { TopicResponseBasicInfoAllOfTwo } from './topicResponseBasicInfoAllOfTwo';

export type TopicResponseBasicInfo = TopicResponseBasicInfoAllOf & TopicResponseBasicInfoAllOfTwo;
